import { render, staticRenderFns } from "./FileSearchSidebar.vue?vue&type=template&id=12397836&scoped=true&"
import script from "./FileSearchSidebar.vue?vue&type=script&lang=js&"
export * from "./FileSearchSidebar.vue?vue&type=script&lang=js&"
import style0 from "./FileSearchSidebar.vue?vue&type=style&index=0&id=12397836&prod&lang=scss&scoped=true&"
import style1 from "./FileSearchSidebar.vue?vue&type=style&index=1&id=12397836&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12397836",
  null
  
)

export default component.exports